import React from 'react';
import { IProposal } from 'interfaces/proposals/proposal';;
import { ProposalListItem } from './proposalListItem';
// import { AuthProvider } from '../../../helpers/authContext'; 

type Props = {
  passingProposals: IProposal[],
  nonPassingProposals: IProposal[],
  returnProposal: IProposal, 
  reloadProposals: (silent?: boolean) => Promise<void>
} 

export const ProposalsList = ({ passingProposals, nonPassingProposals, reloadProposals }: Props) => { 
  
  const renderPassingProposals = passingProposals.map(proposal => (
    <ProposalListItem 
      proposal={proposal} 
      key={proposal.id} 
      style="item-success"
      reloadProposals={reloadProposals} 
    />
  ));
  const renderNonPassingProposals = nonPassingProposals.map(proposal => (
    <ProposalListItem 
      proposal={proposal} 
      key={proposal.id} 
      style="item-warning"
      reloadProposals={reloadProposals} 
    />
  ));
  return (<div>  
    {renderPassingProposals}
    <h3 className="mt-4 text-center">Insufficient Support</h3>
    {renderNonPassingProposals}
  </div>
  )
};